const Board = (props) => {
  return <div className="board" {...props}></div>;
};
export default Board;
